import { EffectsModal } from '../EffectsModal';

export const HousesDamagedModal = ({ title }) => EffectsModal({
  title,
  desc: 'Whenever possible, numbers of houses damaged are listed.',
});
